export default {
  index: 'crm-partner-list-view',
  store: 'crm-partner-create-view',
  edit: 'crm-partner-edit-view',
};
